import type { RouteRecordRaw } from "vue-router";

import { ExpeditionRoutes, TestExpeditionRoutes } from "../enums/routes/ExpeditionRoutes";
import BetaExpeditionLayout from "../layout/app/beta/ExpeditionLayout.vue";
import ExpeditionLayout from "../layout/app/production/ExpeditionLayout.vue";

export function expeditionRoutes(): RouteRecordRaw[] {
    return [
        {
            path: "/expedition",
            component: ExpeditionLayout,
            children: [
                {
                    path: "/expedition",
                    name: ExpeditionRoutes.IDLE,
                    component: () => import("../views/apps/expedition/ExpeditionIdleView.vue"),
                },
                {
                    path: "/expedition/signin",
                    name: ExpeditionRoutes.SIGNIN,
                    component: () => import("../views/apps/expedition/ExpeditionSignInView.vue"),
                },
                {
                    path: "/expedition/settings",
                    name: ExpeditionRoutes.SETTINGS,
                    component: () => import("../views/apps/expedition/ExpeditionUserSettingsView.vue"),
                },
                {
                    path: "/expedition/load",
                    name: ExpeditionRoutes.LOAD_CONTAINER,
                    component: () => import("../views/apps/expedition/ExpeditionLoadContainerView.vue"),
                },
                {
                    path: "/expedition/container/:code",
                    name: ExpeditionRoutes.CONTAINER_VIEW,
                    component: () => import("../views/apps/expedition/ExpeditionContainerView.vue"),
                },
            ],
        },
        {
            path: "/test/expedition",
            component: BetaExpeditionLayout,
            children: [
                {
                    path: "/test/expedition",
                    name: TestExpeditionRoutes.IDLE,
                    component: () => import("../views/apps/test/expedition/ExpeditionIdleView.vue"),
                },
                {
                    path: "/test/expedition/signin",
                    name: TestExpeditionRoutes.SIGNIN,
                    component: () => import("../views/apps/test/expedition/ExpeditionSignInView.vue"),
                },
                {
                    path: "/test/expedition/settings",
                    name: TestExpeditionRoutes.SETTINGS,
                    component: () => import("../views/apps/test/expedition/ExpeditionUserSettingsView.vue"),
                },
                {
                    path: "/test/expedition/load",
                    name: TestExpeditionRoutes.LOAD_CONTAINER,
                    component: () => import("../views/apps/test/expedition/ExpeditionLoadContainerView.vue"),
                },
                {
                    path: "/test/expedition/container/:code",
                    name: TestExpeditionRoutes.CONTAINER_VIEW,
                    component: () => import("../views/apps/test/expedition/ExpeditionContainerView.vue"),
                },
            ],
        },
    ];
}
